var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appInner"},[_c('form',{ref:"form",attrs:{"action":"","method":"POST"},on:{"submit":function($event){$event.preventDefault();}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }